import { PaginacaoModel } from '../models/paginacao.model';
import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IBaseModel } from '../models/base.model';
import { BaseService } from './base.service';
import { IOsaExecucaoEquipeModel, IOsaExecucaoFiltroModel, IOsaExecucaoModel, IOsaExecucaoUgSubTipoModel } from '../models/osa-execucao-model';
import { IOsaExecucaoAuditoresSalvarModel } from '../models/osa-execucao-subtipo-auditoria.model';
import { IValidacaoNivelModel } from '../models/validaca-nivel-aprovacao.model';
import { IEntranharDocumentoModel } from '../models/edocs/entranhar-documento.model';

@Injectable({
  providedIn: 'root'
})
export class OsaExecucaoService extends BaseService {
  public osaExecucaoDate!: IOsaExecucaoModel[];
  private osaExecucaoSource = new BehaviorSubject<any>('');
  public currentOsaExecucao = this.osaExecucaoSource.asObservable();
  private filtrosAplicadosSource = new BehaviorSubject<IOsaExecucaoFiltroModel | null>(null);
  public filtrosAplicados$ = this.filtrosAplicadosSource.asObservable();
  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public obter(filtro?: IOsaExecucaoFiltroModel): Promise<PaginacaoModel<IOsaExecucaoModel[]>> {

    const params = this.recuperarParametrosFiltro(filtro);

    return this.httpClient
      .get<IBaseModel<PaginacaoModel<IOsaExecucaoModel[]>>>(`${this.apiBaseUrl}/osaExecucao`, { params })
      .toPromise().then(result => {
        this.osaExecucaoSource.next(result.dados)
        return result.dados;
      });
  }

  public async obterPorId(id: number): Promise<IBaseModel<IOsaExecucaoModel>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoModel>>(`${this.apiBaseUrl}/osaExecucao/${id}`)
      .toPromise();
  }

  public async inserir(
    data: any): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/osaExecucao/inserir`, data)
      .toPromise();
  }

  private recuperarParametrosFiltro(filtro: IOsaExecucaoFiltroModel): HttpParams {
    let params = new HttpParams();
    if (filtro) {
      if (filtro.numeroOsaObjeto) {
        params = params.append('numeroOsaObjeto', filtro.numeroOsaObjeto?.toString());
      }
      if (filtro.numeroOpa) {
        params = params.append('numeroOpa', filtro.numeroOpa?.toString());
      }
      if (filtro.numeroOsa) {
        params = params.append('numeroOsa', filtro.numeroOsa?.toString());
      }
      if (filtro.unidadeGestoraId) {
        params = params.append('unidadeGestoraId', filtro.unidadeGestoraId?.toString());
      }
      if (filtro.origemAuditoria) {
        params = params.append('origemAuditoria', filtro.origemAuditoria?.toString());
      }
      if (filtro.tipoAuditoriaId) {
        params = params.append('tipoAuditoriaId', filtro.tipoAuditoriaId?.toString());
      }
      if (filtro.dataInicioRealizacao) {
        params = params.append('dataInicioRealizacao', filtro.dataInicioRealizacao?.toString());
      }
      if (filtro.dataFimRealizacao) {
        params = params.append('dataFimRealizacao', filtro.dataFimRealizacao?.toString());
      }
      if (filtro.dataElaboracao) {
        params = params.append('dataElaboracao', filtro.dataElaboracao?.toString());
      }
      if (filtro.coordenadorId) {
        params = params.append('coordenadorId', filtro.coordenadorId?.toString());
      }
      if (filtro.coordenacao) {
        params = params.append('coordenacao', filtro.coordenacao?.toString());
      }
      if (filtro.tipoEnfaseId) {
        params = params.append('tipoEnfaseId', filtro.tipoEnfaseId?.toString());
      }
      if (filtro.subtipoAuditoriaId) {
        params = params.append('subtipoAuditoriaId', filtro.subtipoAuditoriaId?.toString());
      }
      if (filtro.auditorId) {
        params = params.append('auditorId', filtro.auditorId?.toString());
      }
      if (filtro.status) {
        params = params.append('status', filtro.status?.toString());
      }
      if (filtro.ativo !== undefined && filtro.ativo !== null) {
        params = params.append('ativo', filtro.ativo?.toString());
      }
      if (filtro.pagina) {
        params = params.append('pagina', filtro.pagina?.toString());
      }
      if (filtro.itensPorPagina) {
        params = params.append('itensPorPagina', filtro.itensPorPagina?.toString());
      }
      if (filtro.colunaOrder) {
        params = params.append('colunaOrder', filtro.colunaOrder?.toString());
      }
      if (filtro.direcao) {
        params = params.append('direcao', filtro.direcao?.toString());
      }
    }
    return params;
  }

  public async inserirUgSubTipo(data: IOsaExecucaoUgSubTipoModel): Promise<IBaseModel<IOsaExecucaoUgSubTipoModel>> {
    return this.httpClient
      .post<IBaseModel<IOsaExecucaoUgSubTipoModel>>(`${this.apiBaseUrl}/osaExecucao/ugSubTipo/inserir`, data)
      .toPromise();
  }

  public async excluirUgSubTipo(osaExecucaoId: number, unidadeGestoraId: number, subTipoAuditoriaId: number): Promise<IBaseModel<boolean>> {
    return this.httpClient
      .delete<IBaseModel<boolean>>(`${this.apiBaseUrl}/osaExecucao/${osaExecucaoId}/ug/${unidadeGestoraId}/subtipo/${subTipoAuditoriaId}/excluir`)
      .toPromise();
  }

  public async salvarAlocarEquipe(id: number, data: IOsaExecucaoAuditoresSalvarModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/planejamento/${id}/alocar-equipe`, data)
      .toPromise();
  }

  public async obterAlocarEquipe(id: number): Promise<IBaseModel<IOsaExecucaoEquipeModel>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoEquipeModel>>(`${this.apiBaseUrl}/planejamento/${id}/equipes`)
      .toPromise();
  }

  public async enviarAprovacao(id: number): Promise<IBaseModel<IOsaExecucaoModel>> {
      return this.httpClient
        .put<IBaseModel<IOsaExecucaoModel>>(`${this.apiBaseUrl}/osaExecucao/${id}/enviar-aprovacao`, null)
        .toPromise();
  }

   public async verificarNivelAprovacao(id: number): Promise<IBaseModel<IValidacaoNivelModel>> {
      return this.httpClient
        .get<IBaseModel<IValidacaoNivelModel>>(`${this.apiBaseUrl}/osaExecucao/${id}/verificar-nivel-aprovacao`)
        .toPromise();
  }

  public async homologar(id: number, entranharDocumento: IEntranharDocumentoModel): Promise<IBaseModel<IOsaExecucaoModel>> {
      return this.httpClient
        .put<IBaseModel<IOsaExecucaoModel>>(`${this.apiBaseUrl}/osaExecucao/${id}/homologar`, entranharDocumento)
        .toPromise();
  }

  public notificarFiltrosAplicados(filtros: IOsaExecucaoFiltroModel): void {
    this.filtrosAplicadosSource.next(filtros);
  }

  // NOVO: Método para limpar filtros
  public limparFiltros(): void {
    this.filtrosAplicadosSource.next(null);
  }

}
